/**
 * 
 * @param {*} file should contain the file id and name
 * @param {*} tokens needed for the api auth
 * @param {*} session pass the context
 * @returns void - it downloads the file automatically
 */
export const handleDownloadSource = (file, tokens, session) => {
  let _id = file.id;
  let _file_name = file.filename;

  if(!_id || !tokens || !session) { return; }
  
  fetch(`${window.api_url}/query/uploads/download?id=${_id}`, {
    headers: {
      "X-Active-Company": `${session.appState.activeCompany.id}`,
      Authorization: `Bearer ${tokens.accessToken}`,
    },
  }).then((response) => {
    const disposition = response.headers.get('Content-Disposition');
    if (disposition && disposition.includes('filename=')) {
      _file_name = disposition
        .split('filename=')[1]
        .replace(/["']/g, '');
    }
    // remove extra characters from the file extension
    _file_name = _file_name.replace(/(\.[a-z0-9]{3,5})(?:[\s\S]*)$/i, '$1');

    response.blob().then((blob) => {
      let url = window.URL.createObjectURL(blob);
      url = encodeURI(url);
      let a = document.createElement("a");
      a.href = decodeURI(url);
      a.download = _file_name;
      a.click();
    });
  })
};